interface AdminIconProps {
  className?: string;
}

export const AdminIcon = ({ className }: AdminIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2.5L2.5 6.25V10C2.5 14.125 5.7 17.95 10 18.75C14.3 17.95 17.5 14.125 17.5 10V6.25L10 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.625C10.8629 10.625 11.5625 9.92545 11.5625 9.0625C11.5625 8.19956 10.8629 7.5 10 7.5C9.13706 7.5 8.4375 8.19956 8.4375 9.0625C8.4375 9.92545 9.13706 10.625 10 10.625Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.625V13.125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
